module.exports = "<p>praise-night works!</p>\n"